import classNames from "classnames"

import { Img } from "ui-kit/components-branded/index"

export function CourseBanner({ className }: { className?: string }) {
    return (
        <a href="https://alter.ru/course_mail#sub" target="_blank" rel="noreferrer">
            <div className={classNames("course-banner", className)}>
                <div className="course-banner__title">Бесплатный мини-курс</div>
                <div className="course-banner__description">
                    Путеводитель по&nbsp;терапии
                    <br />+ материалы
                    <Img src="camera.png" className="course-banner__camera" />
                    <Img src="book.png" className="course-banner__book" />
                    <Img src="clear-calendar.png" className="course-banner__clearCalendar" />
                </div>
                <Img className="course-banner__present" src="hello.png" />
            </div>
        </a>
    )
}
